import React from 'react'
import { Button } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

import { AdminUITheme } from 'types/AdminUiThemeMui'

type Props = {
  handleClearFilter: () => void
  isDisabled: boolean
}

const ClearAllFiltersButton = (props: Props) => {
  const theme: AdminUITheme = useTheme()
  const { t } = useTranslation()

  const { handleClearFilter, isDisabled } = props
  return (
    <Button
      sx={{ paddingBottom: 0 }}
      onClick={handleClearFilter}
      id="clear-filter"
      size="small"
      style={theme.ParticipantGrid.clearFilterButton}
      disabled={isDisabled}
    >
      {t('filters.clearAll')}
    </Button>
  )
}

export default ClearAllFiltersButton
